// Human-readable duration from seconds, for quiz "time spent" figures.
// 45 -> "45s", 90 -> "1m 30s", 3600 -> "1h 0m".
export default function fmtDuration(totalSeconds?: number | null): string {
  const s = Math.max(0, Math.round(Number(totalSeconds) || 0));
  if (!s) return '—';
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) {
    const rem = s % 60;
    return rem ? `${m}m ${rem}s` : `${m}m`;
  }
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
}
